module.exports = __webpack_public_path__ + "static/img/chrome_img_1.ea6c2e2d.png";